import { ChangeDetectorRef, Component, Inject, NgZone, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SmsService } from '../services/sms-service.service';
import { AuthServiceService } from '../services/auth-service.service';
import { SpinnerService } from '../spinner/spinner.service';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID } from '@angular/core';
import { environment } from 'src/environments/environment';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { v4 as uuidv4 } from 'uuid';

@Component({
    selector: 'payment-popup',
    templateUrl: './payment-popup.component.html',
    styleUrls: ['./payment-popup.component.scss'],
    standalone: false
})
export class PaymentPopupComponent implements OnInit {
  config: any;
  spinner: boolean = false;
  isBrowser: boolean;
  isPurchased: boolean = false;
  pricingEmbbedMap: {url?: any, orderId?: any, sanitizedUrl?: any} = {};

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public dialogRef: any,
    public dialog: MatDialogRef<PaymentPopupComponent>,
   private sanitizer: DomSanitizer,
    @Inject(PLATFORM_ID) platformId?: Object
    ) {
      this.isBrowser = isPlatformBrowser(platformId);
      if(!this.isBrowser) return;
    this.config = this.dialogRef;
  }

  ngOnInit(): void {
     this.customInit();
  }

  async customInit(){
    this.setPricingEmbbed() //embbed pricing
  }

  //configure embbed pricing detail
  setPricingEmbbed(){
    this.pricingEmbbedMap.orderId = uuidv4();
    this.pricingEmbbedMap.url = `${environment.SMS_PORTAL_URL}pricing/plan/APPIWORKS?embed=appiworks&orderid=${this.pricingEmbbedMap.orderId}`;
    this.pricingEmbbedMap.sanitizedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.pricingEmbbedMap.url);

    //start's listening for success event from sms
    window.addEventListener('message', (event) => {
      if (event.data && event.data.sender == "sms" && event.data.status === 'SMS_PAYMENT_SUCCESS') {
        console.log('Payment Successful! Order ID:', event.data.orderId);
        //orderid match make purchased true
        if(event.data?.orderId == this.pricingEmbbedMap?.orderId) {
          this.isPurchased = true;
          // Add 1 second delay before closing the dialog for better UX
          setTimeout(() => {
            this.dialog.close(true);
          }, 1000);
        } 
      }
    });
  }


}
